<template>
  <div class="add_sales_record_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <div>{{ $t('account.name14') }}</div>
    </div>
    <div class="divider">
    </div>
    <div class="add-content">
      <div class="item-title">
        <div>{{ $t('bike.name278') }}</div>
        <div class="xh">*</div>
      </div>
       <div class="zcbh">
        <el-input v-model="postData.ebikeCode" :placeholder="$t('public.name5')" @input="inputEbikeCode"  @blur="blurEbikeCode"></el-input>
        <el-button class="pzsb" type="primary" @click="showScanning">{{ $t('account.name17') }}</el-button>
       </div>

       <div class="item-title" v-if="tenantOptions.length > 1">
        <div>{{ $t('manage.name117') }}</div>
        <div class="xh">*</div>
      </div>
       <div class="zcbh"  v-if="tenantOptions.length > 1">
        <el-select style="width: 100%;" v-model="postData.tenantId" :placeholder="$t('public.name1')" @change="changeDisabled">
    <el-option
      v-for="item in tenantOptions"
      :key="item.tenantId"
      :label="item.tenantName"
      :value="item.tenantId">
    </el-option>
  </el-select>
       </div>

       <div class="item-title">
        <div>{{ $t('account.name18') }}</div>
        <div class="xh">*</div>
      </div>
      <el-date-picker
      style="width: 100%;"
      v-model="postData.saleDate"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      type="date"
      @change="changeDate"
      :placeholder="$t('public.name43')">
    </el-date-picker>
    <div class="item-title">
        <div>{{ $t('account.name19') }}</div>
        <div class="xh">*</div>
      </div>
      <el-upload class="avatar-uploader" action  :http-request="(e) => {handleUpLoadFile(e)}" :show-file-list="false" accept="image/*">
                  <img v-if="postData.invoiceUrl" :src="postData.invoiceUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="primary" class="submit-bt" @click="submit" :disabled="disabled" :loading="loading">{{ $t('public.name13') }}</el-button>
    </div>
    <div class="scan" v-if="isScanning">
      <div class="scan-box">
        <div id="scanning" style="width: 100%;"></div>
      </div>
      <span class="close-scan" @click="stopScan">
          <svg t="1681382339822" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2626" width="200" height="200">
            <path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128.287273c-211.584464 0-383.712727 172.128262-383.712727 383.712727 0 211.551781 172.128262 383.712727 383.712727 383.712727 211.551781 0 383.712727-172.159226 383.712727-383.712727C895.712727 300.415536 723.551781 128.287273 512 128.287273z" fill="#ffffff" p-id="2627"></path>
            <path d="M557.05545 513.376159l138.367639-136.864185c12.576374-12.416396 12.672705-32.671738 0.25631-45.248112s-32.704421-12.672705-45.248112-0.25631l-138.560301 137.024163-136.447897-136.864185c-12.512727-12.512727-32.735385-12.576374-45.248112-0.063647-12.512727 12.480043-12.54369 32.735385-0.063647 45.248112l136.255235 136.671523-137.376804 135.904314c-12.576374 12.447359-12.672705 32.671738-0.25631 45.248112 6.271845 6.335493 14.496116 9.504099 22.751351 9.504099 8.12794 0 16.25588-3.103239 22.496761-9.247789l137.567746-136.064292 138.687596 139.136568c6.240882 6.271845 14.432469 9.407768 22.65674 9.407768 8.191587 0 16.352211-3.135923 22.591372-9.34412 12.512727-12.480043 12.54369-32.704421 0.063647-45.248112L557.05545 513.376159z" fill="#ffffff" p-id="2628"></path>
          </svg>
        </span>
        </div>
  </div>
</template>
<script>
import { wxUploadFile, addSaleRecord, queryEbikeTenantList } from '@/api/h5.js'
import { Html5Qrcode } from 'html5-qrcode'
export default {
  data() {
    return {
      loading: false,
      disabled: true,
      postData: {
        ebikeCode: '',
        saleDate: '',
        invoicePath: '',
        invoiceUrl: '',
        tenantId: ''
      },
      tenantOptions: [],
      isScanning: false
      // accessToken: '',
      // APP_ID: '6656296',
      // API_KEY: '2PbBV8MXTbSpVeigW4K4RLq7',
      // SECRET_KEY: '3kOCI1ed6DRzvTpda9s1lDBakEFU66Ht'
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {
    this.postData.saleDate = this.$moment(new Date()).format('YYYY-MM-DD')
  },
  methods: {
    goBack() {
      this.$router.replace({ path: '/home', query: { tab: '1', title: this.$t('tabmenu.name69') } })
    },
    startScan() {
      this.isScanning = true
      this.$nextTick(() => {
        this.html5QrCode = new Html5Qrcode('scanning')
        this.html5QrCode
          .start(
            { facingMode: 'environment' },
            { fps: 30, aspectRatio: 1, qrbox: { width: 280, height: 280 } },
            (decodedText, decodedResult) => {
              // 以下为自己所需的业务逻辑处理
              this.postData.ebikeCode = decodedText
              this.blurEbikeCode()
              this.stopScan() // 结束扫码
              // alert('识别结果' + decodedText)
            },
            (errorMessage) => {
            }
          ).catch((res) => {
            alert(res)
            this.isScanning = false
          })
      })
    },
    showScanning() {
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          this.startScan()
        }
      }).catch(err => {
        if (typeof window.__wxjs_environment !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
          alert(this.$t('account.name21'))
        } else {
          alert(err)
        }
      })
    },
    stopScan() {
      this.html5QrCode.stop().then(() => {
        this.isScanning = false
      })
    },
    handleUpLoadFile(param) {
      this.fileList = []
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      wxUploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.postData.invoicePath = res.data.objectName
            this.postData.invoiceUrl = res.data.fileUrl
            this.changeDisabled()
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          loading.close()
        })
    },
    inputEbikeCode() {
      this.changeDisabled()
    },
    blurEbikeCode () {
      this.postData.tenantId = ''
      const ebikeCode = this.postData.ebikeCode
      queryEbikeTenantList({ ebikeCode }).then((res) => {
            if (res.code === 200) {
              this.tenantOptions = res.data || []
              if (this.tenantOptions.length === 1) {
                this.postData.tenantId = this.tenantOptions[0].tenantId
              } else if (this.tenantOptions.length === 0 && ebikeCode) {
                // 整车编号不存在或未绑定厂商：明确提示，避免按钮灰掉却无反馈
                this.$message.warning(this.$t('public.name323'))
              }
            }
            this.changeDisabled()
          }).catch(() => {
            this.changeDisabled()
          })
    },
    changeDate() {
      this.changeDisabled()
    },
    changeDisabled() {
      if (this.postData.invoicePath && this.postData.ebikeCode && this.postData.saleDate && this.postData.tenantId) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    submit() {
      this.$confirm(this.$t('account.name20'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          addSaleRecord(this.postData).then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.$router.replace({ path: '/home', query: { tab: '1', title: this.$t('tabmenu.name69') } })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name33')
          })
        })
    }
  }
}
</script>
<style lang="scss">
.add-content{
  .el-input__inner{
    height: 50px;
    line-height: 50px;
    border: 0px solid #DCDFE6;
    border-radius: 0px;
    border-bottom: 1px solid #DDDEE1;
  }
  .el-button{
    border-radius: 100px;
  }
  .el-input__icon {
    display: none;
}
.el-input--prefix .el-input__inner {
  padding-left: 15px;
}
.el-upload {
  cursor: pointer;
  width: 110px;
  height: 110px;
  background: #eee;
}
}
.el-loading-mask{
  top: 54px;
  bottom: 0px;
}
.el-message-box{
    width: 345px !important;
  }
</style>

<style lang="scss" scoped>
.add_sales_record_container {
  background: #fff;
  width: 100%;
  height: 100%;

    /* 扫码样式 */
    .scan {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    .scan-box {
      width: 100%;
    }
    .close-scan {
      position: absolute;
      top: 20px;
      right: 20px;
      svg {
        width: 40px;
        height: 40px;
      }
    }
  }
  .start-scan{
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 200px;
    height: 50px;
    background: #00aaff;
    color: #fff;
    border-radius: 10px;
  }
  .add-content{
    width: calc(100% - 30px);
    height: calc(100vh - 112px);
    overflow: auto;
    display: flex;
    margin-left: 15px;
    flex-direction: column;
    .avatar-uploader{
      margin-top: 8px;
      width: 110px;
      height: 110px;
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 110px;
        height: 110px;
        line-height: 110px;
        text-align: center;
      }
      .avatar{
        width: 110px;
        height: 110px;
      }
    }
    .submit-bt{
      border-radius: 4px;
      margin-top: 85px;
    }
    .item-title{
      display: flex;
      flex-direction: row;
      font-size: 15px;
      color: #555;
      margin-top: 15px;
      .xh{
        color: #EA4646;
        margin-left: 5px;
      }
    }
    .zcbh{
      width: 100%;
      position: relative;
    }
    .pzsb{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .divider{
    width: 100%;
    height: 10px;
    background: #F6F7FB;
  }

.top-layout {
  display: flex;
  align-items: center;
  position: relative;
  height: 54px;
  .el-icon-arrow-left {
   font-size: 18px;
   font-weight: 600;
   margin-left: 15px;
   cursor: pointer;
  }
  div {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    font-weight: 800;
    line-height: 28px;
    text-align: left;
    color: #171717;
  }
}
}
</style>
